
import Cell from 'vux/src/components/cell/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

export default{
components:{
Cell,
PopupPicker,
},
data(){
return {
showPopupPicker:false, //显示弹出的日历

list3:[],
jsPerson:sessionStorage.getItem('jbpersonNum') || '1',
showPickerPerson:false,
jspickerPerson:[],
upMsg:"请选择上车地点",
downMsg:"请选择下车地点",
jbStorage:JSON.parse(localStorage.getItem("jbStorage"))||{}
}
},
props:["upvalue","downvalue","personList","label"],
watch:{
jspickerPerson:function(newValue,oldValue){
this.jbStorage = JSON.parse(localStorage.getItem("jbStorage"));
this.jsPerson = this.jspickerPerson.join('');

this.$emit('input',this.jsPerson);
if(this.jbStorage){
this.jbStorage.personNum = newValue
localStorage.setItem('jbStorage',JSON.stringify(this.jbStorage))
}

},
"$route": function(from, to){

if(to.path.indexOf("pickupStation") != -1 || to.path.indexOf("giveawayStation") != -1 || to.path.indexOf("pickupAircraft") != -1 ||to.path.indexOf("giveawayAircraft") != -1)
{

!window.localStorage.getItem("jbStorage")?this.jsPerson = 1:"";
}
}
},
methods:{
yz(val){
return this.$until.yzFontColor(val);
},
selectPerson(){
this.upMsg = !this.label ? "请选择接机起始点" : this.upMsg;
this.downMsg = !this.label ? "请选择接机终点" : this.downMsg;

if (typeof  this.upvalue != "object"){
this.$vux.toast.show({
text:this.upMsg,
type:"text"
})
return;
} else if (!this.downvalue){
this.$vux.toast.show({
text:this.downMsg,
type:"text"
})
return;
}
this.showPickerPerson = true;
}
},
mounted(){
if(this.jbStorage.personNum){
this.jspickerPerson = this.jbStorage.personNum
return;
}
/*this.jsPerson =  "1";*/
}
}



// WEBPACK FOOTER //
// ./src/components/common/personPick.vue